module.exports = "/_next/static/images/hyperpie-drops-ea6c07bf7eab3a360ff939f193fababc.png";